// angular
// 	.module("HeroPRO")
// 	.factory("NotificationUtility", notificationUtilityFactory);

import _ from 'lodash';

/* @ngInject */
export default function notificationUtilityFactory(HPNotificationPriority, HPNotifications) {
    return {
        buildNotificationConfiguration,
        buildRequiredNotifications,
    };

    function buildNotificationConfiguration(notifications) {
        const messagePrefix = 'ACTION REQUIRED - ';
        const messages = [];
        let concatenatedMessage = '';
        let openNonMandatoryNotifications = [];
        let notificationColor = 'default'; // default || warning

        // Only process notifications that are not mandatory
        openNonMandatoryNotifications = _.filter(notifications, notification => notification.Priority !== HPNotificationPriority.Mandatory && !notification.isComplete);

        _.each(openNonMandatoryNotifications, (notification, index) => {
            if (index > 0) {
                messages.push('and');
            }

            if (notification.ActionItemTypeId === HPNotifications.DelayedMandatoryTraining.actionItemTypeId) {
                const trainingMessage = ' - You have {0} day(s) to go through our guidelines on working together.';
                messages.push(trainingMessage.replace('{0}', notification.DaysDueCount.toString()));
            } else {
                messages.push(notification.Message);
            }

            if(notification.ActionItemTypeId === 22) {
                // Show as warning if CSLB notification is present
                notificationColor = 'warning';
            }
        });

        concatenatedMessage = messages.join(' ');

        if (concatenatedMessage !== '') {
            return {
                message: `${messagePrefix + messages.join(' ')}.`,
                color: notificationColor
            };
        }

        return {
            message: concatenatedMessage,
            color: notificationColor
        };
    }

    function buildRequiredNotifications(notifications) {
        const required = [];

        _.each(notifications, (notification) => {
            if (notification.Priority === HPNotificationPriority.Mandatory) {
                required.push(notification);
            }
        });

        return required;
    }
}



// WEBPACK FOOTER //
// ./src/app/notificationCenter/notificationUtilityFactory.js